import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@app/_services/auth.service';
import { CacheService } from '@app/_services/cache.service';
import { SettingsService } from '@app/_services/settings.service';
import { StorageService } from '@app/_services/storage.servive';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { BRAND_CONFIG } from '@app/_generated/brand.gen';
import { BRAND_FULL_LOGO } from '@app/_utils/brand-icons';

@Component({
  selector: 'app-account-deleted',
  imports: [
    CommonModule,
    SvgComponent,
  ],
  templateUrl: './account-deleted.component.html',
  styleUrl: './account-deleted.component.scss'
})

export class AccountDeletedComponent {

  readonly brandName = BRAND_CONFIG.name;
  readonly brandFullLogo = BRAND_FULL_LOGO;

  constructor(
    public ss: SettingsService,
    public cc: CacheService,
    public authService: AuthService,
    public storageService: StorageService,
    private router: Router
  ) { }

  goToLogin() {
    this.storageService.clearSensitiveData();
    this.ss.viewSignals()['appTheme'].set('dark');
    this.ss.viewSignals()['themeColor'].set('a');
    this.ss.reset();

    this.router.navigate(['/login']);
  }

}
